// extracted by mini-css-extract-plugin
module.exports = {"debtCard":"_2nEYvvxiEeuurCfyfPqT5M","formHolder":"_2QjO4dK1N24mff5ptWps_Z","avatarHolder":"RrgFx7sWIaruY7S6lbfAY","arrow":"uBhSAd4QWpdGXOee2YMy1"};